import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table-v6';
import { makeFirstLetterCapital, CustomNoDataComponent, getUser, convertInventoryDateTimezone } from '../../../../../utility/utility';
import { MagicSpinner, PushSpinner, SwishSpinner, WaveSpinner, ClapSpinner } from 'react-spinners-kit';
import '../../../../../../node_modules/react-table-v6/react-table.css';
import { useSelector, useDispatch } from 'react-redux';
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import * as actions from '../../../../../redux/actions/index';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Select } from 'antd';
import { qrCodeSize_option } from '../../../../../utility/constants/constants';
import Dialog from '@material-ui/core/Dialog';
import moment from 'moment';

const AssetsListTable = (props) => {
  const [pageSize, setPageSize] = useState(10);
  const [openModel, setOpen] = useState(false);
  const [openQrModel, setQROpen] = useState(false);
  const [currentQrArea, setCurrentQrArea] = useState({});
  const [qrCodeSize, setQrCodeSize] = useState('medium');
  const [qrCodeSize_MedSmall, setQrCodeSize_MedSmall] = useState(null);
  const [isQrCodeRender, setIsQrCodeRender] = useState(false);

  const dispatch = useDispatch();
  const SearchValue = useSelector(state => state.form.searchAssetsListForm && state.form.searchAssetsListForm.values ? state.form.searchAssetsListForm.values : {});
  const DateGenerate = useSelector(state => state.InventoryReducer.dataGenerated);
  const values = useSelector(state => state.InventoryReducer.assets_searchValues);
  const SearchOrResetAssetsClicked = useSelector(state => state.InventoryReducer.SearchOrResetAssetsClicked);
  const No_of_pages = useSelector(state => state.InventoryReducer.assests_pages);
  const No_of_rows = useSelector(state => state.InventoryReducer.assests_no_of_rows);
  const assestsCurPage = useSelector(state => state.InventoryReducer.assestsCurPage);

  const printQr = () => {
    const input = document.getElementsByClassName("qr-body-single")[0];
    html2canvas(input, { useCORS: true, allowTaint: true })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'PNG', 10, 10);
        //pdf.output('dataurlnewwindow');
        pdf.save("download.pdf");
      })
  };

  // useEffect(() => {
  //   if (SearchOrResetAssetsClicked) {
  //       dispatch(actions.resetSearchOrResetInventory())
  //   } else {
  //     const page = 1;
  //     const limit = props.assests_no_of_rows
  //     const type = 'asset'
  //     const status = props.activeAssets ? 'active' : 'inactive'
  //     props.getAllAssests({page, limit, type, status}, values);
  //   }
  // }, [props.activeAssets]);

  const data = props.assestsList && props.assestsList.map(asset => {
    
    return {
      // sku_detail: makeFirstLetterCapital(asset.sku_detail),
      id: asset && asset.id ? asset.id : '-',
      name: makeFirstLetterCapital(asset.name),
      manufacture: makeFirstLetterCapital(asset.manufacture),
      initial_quantity: asset.item ? asset.item.initial_quantity : '-',
      current_quantity: asset.item ? asset.item.current_quantity : '-',
      supplier: asset && asset.supplier ? makeFirstLetterCapital(asset.supplier) : '-',
      next_service_date: asset && asset.expiration_date ? convertInventoryDateTimezone(asset.expiration_date,"MM-DD-YYYY ").toUpperCase()  : '-',
      purchase_date:asset && asset.purchase_date ? convertInventoryDateTimezone(asset.purchase_date,"MM-DD-YYYY").toUpperCase() : '-' ,
      initial_cost:asset && asset.initial_cost ? asset.initial_cost : '-',
      facility: asset && asset.facility ? asset.facility : '-',
      location: asset && asset.location ? asset.location : '-',
      life_expectancy: asset && asset.life_expectancy ? asset.life_expectancy : '-',
      cost_at_replacement: asset && asset.cost_at_replacement ? asset.cost_at_replacement : '-',
      salvage_date: asset && asset.salvage_date ? convertInventoryDateTimezone(asset.salvage_date,"MM-DD-YYYY") : '-' ,
      actions: <>
        <span className="mr_20 account_edit_icn" onClick={() => props.assetStockClicked(asset)}><i class="fas fa-eye" aria-hidden="true" ></i></span>
        <span className="mr_20 account_edit_icn" onClick={() => props.history.push(`/assets/${asset.id}`)}><i class="fa fa-pencil" aria-hidden="true" ></i></span>
        <span className="mr_20 account_edit_icn" onClick={() => props.handleInventoryOpenDeleteModal(asset)}><i class="fa fa-trash" aria-hidden="true" ></i></span>
      </>

    }
  })


  const columns = [
    {
      Header: <><span>Asset Id</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'id', // String-based value accessors!,
      show: props.assestsList.length !== 0,
    },
    {
      Header: <><span>Asset Name</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'name', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Manufacturer</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'manufacture', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Quantity</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'initial_quantity', // String-based value accessors!,
      show: props.assestsList.length !== 0,
    },
    {
      Header: <><span>Instock Quantity</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'current_quantity', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Suppliers</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'supplier', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Next Service Date</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'next_service_date', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Purchase Date</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'purchase_date', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Initial Cost</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'initial_cost', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Facility</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'facility', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Location</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'location', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Life Expectancy</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'life_expectancy', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Cost at Replacement</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'cost_at_replacement', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: <><span>Salvage Date</span><FaArrowUp className="icon-asc" /><FaArrowDown className="icon-desc" /> </>,
      accessor: 'salvage_date', // String-based value accessors!,
      show: props.assestsList.length !== 0,
      width : 235
    },
    {
      Header: " ",
      accessor: "actions",
      show: props.assestsList.length !== 0,
      width: 100
    }
  ]

  const [tablePage, setTablePage] = useState(0)
  const tablePageNew = React.useRef()
  if (assestsCurPage !== tablePageNew.current) {
    tablePageNew.current = assestsCurPage;
  }
  const setTablePageFn = (page) => {
    setTablePage(page)
    props.assetsPageClicked(page)
    tablePageNew.current = page;
  }

  const fetchData = (state, instance) => {
    if (SearchOrResetAssetsClicked) {
      dispatch(actions.resetSearchOrResetInventory())
    } else {
      if (!DateGenerate) {
        state.page = 2;
        const limit = state.pageSize;
        const fl_users_no_of_rows = state.pageSize;
        let page = tablePageNew.current >= 0 ? tablePageNew.current + 1 : assestsCurPage + 1;
        if (No_of_rows != fl_users_no_of_rows) {
          page = 1;
          setTablePageFn(0)
        }
        const sorted = state.sorted;
        const type = 'asset'

        const id = SearchValue.id ? SearchValue.id : '';
        const name = SearchValue.name ? SearchValue.name : '';
        props.getAllAssests({ page, limit, sorted, id, name, type }, values)
      }
    }
    // }
  }
  const handleConfirm = (confirm) => {
    setOpen(false);
    //props.deleteArea(currentArea.id, props.match.params.accountId)
  };

  const handleQrCodeSizeRender = (size) => {
    setIsQrCodeRender(true);
    if (size == 'medSmall') {
      setQrCodeSize(null);
      setQrCodeSize_MedSmall('small');
    } else {
      setQrCodeSize_MedSmall(null);
      setQrCodeSize(size);
    }
    setTimeout(() => {
      setIsQrCodeRender(false);
    }, 1000);
  };

  return (
    SearchOrResetAssetsClicked && props.isLoading ?
      <div className="loader_btn_block">
        <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
      </div>
      :
      <> <ReactTable
        data={data}
        loading={props.isLoading}
        defaultPageSize={No_of_rows ? No_of_rows : pageSize}
        minRows={0}
        manual
        onFetchData={fetchData}
        pages={No_of_pages}
        gotoPage={assestsCurPage}
        page={assestsCurPage}
        onPageChange={(page) => { setTablePageFn(page) }}
        onPageSizeChange={(e) => setPageSize(e)}
        showPaginationTop={true}
        showPaginationBottom={false}
        showPagination={props.assestsList.length !== 0}
        columns={columns}
        NoDataComponent={() => CustomNoDataComponent(props.isLoading, 'No Assests Found')}
        getTheadThProps={(state, rowInfo, column, instance) => {
          return {
            style: {
              borderTop: 'none',
              borderBottom: 'none',
              borderRight: 'none',
              textAlign: 'center',
              color: '#566975',
              fontSize: '14px',
              fontWeight: '600',
              whiteSpace: 'nowrap',
              float: 'left',
            }
          }
        }
        }
        LoadingComponent={() =>
          props.isLoading ?
            <div style={{
              display: "block",
              position: "absolute",
              left: 0,
              height: '100%',
              right: 0,
              background: "rgba(255,255,255,0.8)",
              transition: "all .3s ease",
              top: 0,
              bottom: 0,
              textAlign: "center"
            }}
              className="loader_btn_block">
              <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />
            </div> : null}
        getTrProps={(state, rowInfo, column, instance) => {
          return {
            className: 'react-table-tr-element',
            style: {
              border: '1px solid #c7cdd1',
              transition: '.3s ease-in-out',
              width: '100%',
              marginTop: '5px',
              float: 'left'
            }
          }

        }}
        getTdProps={(state, rowInfo, column, instance) => {

          if (column.id == 'image') {
            return {
              style: {
                marginTop: '0px'
              }
            }
          } else {
            return {
              className: 'react-td-element',
            }
          }
        }
        }
        getProps={() => {
          return {
            style: {
              border: 'none'
            }
          }
        }}
      />
        <Dialog
          open={openQrModel}

          aria-labelledby="form-dialog-title"
        >
          <div className="row p-0 m-0">
            <div className="col-10">
              <h4 id="form-dialog-title" className="p-2" style={{ textAlign: "left", fontSize: '13', color: '#ab385e' }}>
                QR Code
              </h4></div>
            <div className="col-2">
              <span onClick={() => { handleQrCodeSizeRender('medium'); setQROpen(false); }} className="float-right text-right mt-2 cursor-pointer"><i className="fa fa-times"></i></span>
            </div>
          </div>
          <div className="qr-body-single" style={{
            display: "flex",
            justifyContent: "center"
          }}>
            {isQrCodeRender ? (
              <ClapSpinner backColor="#89073c" size={40} frontColor="#89073c8a" />) : (
              <img src={currentQrArea && currentQrArea.photo_urls && currentQrArea.photo_urls[qrCodeSize ? qrCodeSize : qrCodeSize_MedSmall]} style={{
                maxHeight: qrCodeSize == "original" ? "75vh" : "unset",
                width: qrCodeSize == "original" ? "41vw" : qrCodeSize_MedSmall ? "1.25in" : "unset"
              }} alt="dfdf" />
            )}
            {/* <img src={currentQrArea && currentQrArea.attachments ? currentQrArea.attachments[0].photo_urls.medium : null} alt="dfdf" /> */}
          </div>

          <div className="qrCode_sizeSetup_antd_select p-2">
            <Select
              suffixIcon={null}
              className={"btn cst_btn btn_danger mr-2"}
              style={{ minHeight: '51px', minWidth: '80px' }}
              placement={"bottomRight"}
              defaultValue='medium'
              options={qrCodeSize_option}
              onChange={(size) => { handleQrCodeSizeRender(size); }}
            />
            <button style={{ minHeight: '51px', minWidth: '80px' }} onClick={() => printQr()} className={"float-right btn mr-2 cst_btn btn_danger"} id="cancel" type="cancel">Get PDF</button>
            <button style={{ minHeight: '51px', minWidth: '80px' }} onClick={() => window.print()} disabled={props.isLoading} className={props.isLoading ? "float-right btn cst_btn btn_danger mr-2 btn-wait" : "float-right btn cst_btn btn_danger mr-2"} id="delete" type="delete">{props.isLoading ? "" : "Print QR"}</button>
          </div>
        </Dialog>

      </>
  )
}

export default AssetsListTable;